import classNames from 'classnames'
import { ReactNode } from 'react'

interface IProps {
  classes?: string
  children: ReactNode
}

export const UnitContentCard = ({ classes, children }: IProps) => (
  <div className={classNames(classes, 'px-5 lg:px-6 py-4 lg:py-6 bg-surface rounded-[30px] border border-border')}>{children}</div>
)
